import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const records = async (params: object) => {
  return await GET({ url: Api.records, params, showError: false })
}
